import { ParkingPageId } from '../../../../domain/pages/ParkingPageId';
import { IBooking } from '../../../../domain/booking/models/IBooking';
import { useUrlForPageId } from '../../../../../app/pages/ui/utils/useUrlForPageId';

export function usePartialAmendUrl(booking: IBooking): string {
	const pageUrl = useUrlForPageId(ParkingPageId.PartialAmendBookingDetails);

	return `${pageUrl}?reference=${booking.reference}`;
}
